import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, of } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatChip } from '@angular/material';
import { ClienteService } from '../../services/cliente.service';
import { ExcluirClienteComponent } from '../excluir-cliente/excluir-cliente.component';
import { Element } from '@angular/compiler';
import { ClientesModel } from '../clientes/clientes.model';
import { AlertService } from '../../providers/alert.service'

@Component({
	selector: 'app-clientes',
	templateUrl: './clientes.component.html',
	styleUrls: ['./clientes.component.scss', '../../assets/less/all.less']
})
export class ClientesComponent implements OnInit {

	cliente = {
		id: null,
		razao_social: null,
		nome_fantasia: null,
		cnpj: null,
		logradouro: null
	}

	id = -1;
	displayedColumns = ['cod_cliente', 'razao_social', 'acoes'];
	dataSource: ClienteDataSource | null;
	isTableAvailable = false
	public loading = false;

	length: number;
	pageIndex: number = 1;
	pageSize: number = 10;
	pageSizeOptions: number[] = [5, 10, 25, 50, 100];
	data: any;

	constructor(
		public router: Router,
        public cliente_service: ClienteService,
        public dialog: MatDialog,
		public alerts: AlertService
	) { }

	ngOnInit() {
	}

	buscar() {
        this.loading = true;
        cliente = null;
        this.isTableAvailable = false;
        this.loadData();
    }

    loadData() {
        this.cliente_service.getCliente(this.cliente['id'], this.cliente['razao_social'])
            .then(data => {
                if (data['items']) {
                    cliente = data['items'];
                    console.log(data);
                    // this.setPagination(data['_meta']['totalCount'], data['_meta']['currentPage'], data['_meta']['perPage']);
                    this.dataSource = new ClienteDataSource(cliente);
                    console.log("datasource", this.dataSource)
                    this.isTableAvailable = true;
                    this.loading = false;
                } else {
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                }
            })
            .catch(error => {
                this.loading = false;
            });
    }

	openCadastroCliente() {
		this.router.navigate(['/cadastro-cliente', this.id])
	}
	
    setPagination(length, startIndex, pageSize) {
        this.length = length;
        this.pageIndex = startIndex;
        this.pageSize = pageSize;
    }

    onPaginateChange(event) {
        console.log("evento")
        console.log(event);
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        console.log(this.pageSize)
        this.loading = true;
        // this.loadData();
	}
	
	
    alterar(id) {
        this.router.navigate(['cadastro-cliente', id])
    }

    excluirCliente(cliente) {
        let dialogRef = this.dialog.open(ExcluirClienteComponent, {
            width: '700px',
            data: cliente
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                cliente = null;
                this.loadData();
            }
        });
    }

}


let cliente;

export interface Element {
    id: null,
    razao_social: null,
    nome_fantasia: null,
    cnpj: null,
    logradouro: null,
    numero: null,
    complemento: null,
    cep: null,
    bairro: null,
    cidade: null,
    uf: null,
    telefone: null,
    email: null,
    site: null,
    status: null,
    nome_contato: null,
    created_at: null,
    created_by: null,
    updated_at: null,
    updated_by: null
}

export class ClienteDataSource extends DataSource<any> {
	connect(): Observable<ClientesModel[]> {
		console.log(cliente);
		return of(this._cliente);
	}

	constructor(private _cliente: ClientesModel[]) {
		super();
	}

	disconnect() { }
}
